module.exports = __webpack_public_path__ + "static/img/v-bg.e28aa8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-nine/v-bg.png
// module id = OTvK
// module chunks = 0